"use client";

import { useState } from "react";
import { Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
export default function Faq() {
  const categories = [{
    id: "all",
    label: "WSZYSTKIE"
  }, {
    id: "technologia",
    label: "TECHNOLOGIA"
  }, {
    id: "proces",
    label: "PROCES"
  }, {
    id: "gwarancja",
    label: "GWARANCJA"
  }, {
    id: "wycena",
    label: "WYCENA"
  }];
  const faqs = [{
    id: "01",
    category: "technologia",
    question: "Czym jest bezspoinowa hydroizolacja natryskowa?",
    answer: "To nowoczesna metoda aplikacji płynnej membrany, która tworzy jednolitą, elastyczną powłokę bez łączeń. Dzięki temu skutecznie eliminuje ryzyko przecieków w miejscach, gdzie tradycyjna papa często zawodzi.",
    spec: "HR-01 · MEMBRANA · BEZSPOINOWA"
  }, {
    id: "02",
    category: "proces",
    question: "Czy konieczne jest zrywanie starego pokrycia dachowego?",
    answer: "W większości przypadków nie. Nasza technologia pozwala na aplikację bezpośrednio na istniejące podłoże, co znacząco obniża koszty inwestycji i skraca czas realizacji prac remontowych.",
    spec: "HR-02 · SZYBKI · MONTAŻ"
  }, {
    id: "03",
    category: "technologia",
    question: "Jak powłoka reaguje na promieniowanie UV i warunki atmosferyczne?",
    answer: "Stosowane przez nas materiały są w pełni odporne na promieniowanie UV oraz ekstremalne wahania temperatur. Powłoka zachowuje swoje właściwości hydroizolacyjne przez wiele lat, nie pękając pod wpływem słońca.",
    spec: "HR-03 · ODPORNOŚĆ · UV"
  }, {
    id: "04",
    category: "gwarancja",
    question: "Jaki okres gwarancji obejmuje wykonane prace?",
    answer: "Na nasze realizacje udzielamy wieloletniej gwarancji technicznej. Jakość użytych materiałów oraz precyzja aplikacji natryskowej zapewniają trwałość, której jesteśmy pewni w każdych warunkach.",
    spec: "HR-04 · GWARANCJA · JAKOŚCI"
  }, {
    id: "05",
    category: "proces",
    question: "Czy hydroizolacja nadaje się na dachy przemysłowe?",
    answer: "Tak, nasze rozwiązania są idealne dla hal magazynowych, zakładów produkcyjnych i obiektów wielkopowierzchniowych. Szybkość aplikacji pozwala na minimalizację przestojów w pracy obiektu.",
    spec: "HR-05 · PRZEMYSŁ · HALA"
  }, {
    id: "06",
    category: "wycena",
    question: "Jak uzyskać bezpłatną wycenę hydroizolacji?",
    answer: "Wystarczy skontaktować się z nami poprzez formularz na stronie lub telefonicznie. Nasi specjaliści dokonają oceny stanu dachu i przygotują szczegółową ofertę dopasowaną do Państwa potrzeb.",
    spec: "HR-06 · WYCENA · BEZPŁATNA"
  }, {
    id: "07",
    category: "proces",
    question: "Czy wykonujecie hydroizolację tarasów i balkonów?",
    answer: "Oczywiście. Nasze systemy doskonale sprawdzają się na tarasach i balkonach, tworząc szczelną barierę chroniącą konstrukcję budynku przed wilgocią i degradacją betonu.",
    spec: "HR-07 · TARASY · BALKONY"
  }, {
    id: "08",
    category: "wycena",
    question: "Czy przygotowujecie dokumentację dla wspólnot mieszkaniowych?",
    answer: "Tak, dostarczamy pełną dokumentację techniczną, kosztorysy oraz specyfikacje materiałowe niezbędne do rozliczeń inwestycji w spółdzielniach i wspólnotach mieszkaniowych.",
    spec: "HR-08 · DOKUMENTACJA · PO"
  }];
  const [activeCategory, setActiveCategory] = useState("all");
  const filteredFaqs = activeCategory === "all" ? faqs : faqs.filter(f => f.category === activeCategory);
  return <section data-section-id="4978" id="częste-pytania" className="bg-background text-foreground py-20 md:py-[140px] px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="mb-16 md:mb-24">
          <div className="font-mono text-xs uppercase tracking-widest text-primary mb-6">
            § FAQ / HYDRO-ROOF
          </div>
          <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] font-semibold leading-[1.05] tracking-tight text-foreground">
            Najczęstsze pytania.
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-6 pb-4 border-b border-border">
                ※ INDEKS KATEGORII
              </div>
              <nav className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible">
                {categories.map((cat, i) => {
                const isActive = activeCategory === cat.id;
                return <Button data-index={i} key={cat.id} onClick={() => setActiveCategory(cat.id)} variant="ghost" className={`font-mono text-xs uppercase tracking-widest text-left h-auto py-3 px-4 border-l-2 rounded-none justify-start transition-all whitespace-nowrap ${isActive ? "border-l-primary text-foreground bg-card" : "border-l-transparent text-muted-foreground hover:text-foreground hover:border-l-border hover:bg-transparent"}`}>
                      <span className="opacity-50 mr-3">
                        {String(i).padStart(2, "0")}
                      </span>
                      {cat.label}
                    </Button>;
              })}
              </nav>

              <div className="mt-10 pt-6 border-t border-border hidden lg:block">
                <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground space-y-2">
                  <div className="flex justify-between">
                    <span>WPISY</span>
                    <span className="text-foreground">
                      {String(filteredFaqs.length).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>STATUS</span>
                    <span className="text-primary">AKTYWNY</span>
                  </div>
                </div>
              </div>
            </div>
          </aside>

          {}
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {filteredFaqs.map((faq, i) => <AccordionItem data-index={i} key={faq.id} value={faq.id} className="border-b-0 border-t border-border first:border-t group/item">
                  <AccordionTrigger className="hover:no-underline py-6 [&>svg]:hidden group">
                    <div className="flex items-start gap-6 md:gap-10 w-full pr-4">
                      <span className="font-mono text-xs text-muted-foreground mt-1 shrink-0">
                        {faq.id}
                      </span>
                      <span className="font-default text-base md:text-lg text-foreground text-left flex-1 transition-transform duration-200 group-hover:translate-x-1 group-data-[state=open]:translate-x-1">
                        {faq.question}
                      </span>
                      <span className="shrink-0 mt-1">
                        <Plus className="size-4 text-primary transition-transform duration-300 group-data-[state=open]:rotate-45" strokeWidth={1.5} />
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6">
                    <div className="ml-0 md:ml-[3.25rem] pl-6 md:pl-10 border-l border-border space-y-4">
                      <p className="font-default text-[15px] leading-relaxed text-muted-foreground">
                        {faq.answer}
                      </p>
                      <p className="font-mono text-[10px] uppercase tracking-widest text-primary/80">
                        {faq.spec}
                      </p>
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>

            {}
            <div className="mt-12 border border-primary bg-card p-6 md:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6 rounded-md">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-primary mb-2">
                  ※ KANAŁ BEZPOŚREDNI
                </div>
                <p className="font-mono text-sm uppercase tracking-wider text-foreground">
                  Masz więcej pytań?
                </p>
              </div>
              <Button asChild variant="ghost" className="font-mono text-xs uppercase tracking-widest text-primary hover:text-primary hover:bg-primary/10 self-start md:self-auto px-4 h-auto py-2">
                <Link to="/ContactPage">
                  SKONTAKTUJ SIĘ
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}